module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Hazel_diameter.811b6d38.png";